/* FB | PC ETKILESIM DUZELTMELERI (2026-06-14)
   SADECE FARE (PC). Dokunmatik/mobile HIC ETKILENMEZ (native davranis korunur).
   1) Sepet "Kasa Onu Firsatlari" (.fb-kof__card): duz fare tiklamasi urune GITSIN.
      (Mevcut surukle/pointer-capture mantigi, kart bir <a> oldugu halde click'i yutuyordu.
       Surukleyerek kaydirma AYNEN korunur; sadece hareketsiz tiklama urune gider.)
   2) "Sizden Gelenler" (.fb-tst__strip): PC'de fare ile TUTUP saga-sola surukle-kaydir.
      (Serit zaten overflow-x:auto; sadece fare surukleme eklenir. Mobil native kaydirma aynen.) */
(function () {
  'use strict';
  if (window.__fbPcInteract) return;
  window.__fbPcInteract = true;

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  /* ===== 1) KOF kart: hareketsiz fare tiklamasi -> urune git ===== */
  (function () {
    var d = null;
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') { d = null; return; }
      var card = e.target.closest && e.target.closest('.fb-kof__card');
      if (!card) { d = null; return; }
      var href = card.getAttribute('href');
      d = href ? { x: e.clientX, y: e.clientY, href: href, id: e.pointerId } : null;
    }, true);
    document.addEventListener('pointerup', function (e) {
      if (!d || e.pointerType !== 'mouse' || e.pointerId !== d.id) { d = null; return; }
      var moved = Math.abs(e.clientX - d.x) > 5 || Math.abs(e.clientY - d.y) > 5;
      var href = d.href; d = null;
      if (!moved && href) { window.location.href = href; }
    }, true);
  })();

  /* ===== 2) Sizden Gelenler: PC fare surukle-kaydir ===== */
  function setupStrip(strip) {
    if (!strip || strip.__fbStripDrag) return;
    strip.__fbStripDrag = true;
    strip.style.cursor = 'grab';
    var down = false, sx = 0, sl = 0, snap = '';
    strip.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; sx = e.clientX; sl = strip.scrollLeft;
      snap = strip.style.scrollSnapType;
      strip.style.scrollSnapType = 'none';
      strip.style.scrollBehavior = 'auto';
      strip.style.userSelect = 'none';
      strip.style.cursor = 'grabbing';
    });
    document.addEventListener('mousemove', function (e) {
      if (!down) return;
      strip.scrollLeft = sl - (e.clientX - sx);
      if (e.cancelable) e.preventDefault();
    });
    function endDrag() {
      if (!down) return;
      down = false;
      strip.style.cursor = 'grab';
      strip.style.userSelect = '';
      strip.style.scrollSnapType = snap;
      strip.style.scrollBehavior = '';
    }
    document.addEventListener('mouseup', endDrag, true);
    document.addEventListener('mouseleave', endDrag, true);
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function initStrips() {
    if (isMobile()) return;
    var strips = document.querySelectorAll('.fb-tst__strip');
    for (var i = 0; i < strips.length; i++) setupStrip(strips[i]);
  }

  function boot() {
    initStrips();
    document.addEventListener('shopify:section:load', initStrips);
    setTimeout(initStrips, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
